import React from "react";
import { cn } from "@/lib/utils";
import { getCurrencyForCountry } from "@/lib/countryDetection";

interface PriceLevelProps {
    level: number;
    country?: string;
    className?: string;
    size?: "sm" | "md" | "lg";
}

export function PriceLevel({ level, country = "NL", className, size = "md" }: PriceLevelProps) {
    const symbol = getCurrencyForCountry(country);
    const safeLevel = Math.max(0, Math.min(5, Math.round(level)));

    const sizeClasses = {
        sm: "h-5 w-5 text-[10px]",
        md: "h-7 w-7 text-xs",
        lg: "h-10 w-10 text-sm",
    };

    return (
        <div className={cn("flex items-center gap-1", className)}>
            {[1, 2, 3, 4, 5].map((i) => (
                <div
                    key={i}
                    className={cn(
                        "flex items-center justify-center rounded-full font-bold transition-colors",
                        sizeClasses[size],
                        i <= safeLevel
                            ? "bg-primary text-primary-foreground shadow-sm"
                            : "bg-muted text-muted-foreground/40"
                    )}
                >
                    {symbol}
                </div>
            ))}
        </div>
    );
}
